import React, {useEffect, useState} from 'react';
import {initializePaddle, Paddle} from '@paddle/paddle-js';
import "./PricingPlans.css"
import api from "../../utils/api.js";

const money = (minor: string) => {
    const currencyCode = "USD";
    return <>{
        new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: currencyCode,
            minimumFractionDigits: 0,
        }).format(Number(minor) / 100)
    }</>
}


function PricingCard({ id, name, amount, interval, trialPeriod, onChoose, isCurrent, children }: any) {
    let displayAmount = <>
        {money(amount)}
        <span className="plan-interval">/ {interval}</span>
    </>
    if (amount === "0") {
        displayAmount = <>Free</>
    }
    if (amount === "sales") {
        displayAmount = <>Contact Sales</>
    }


    return (
        <section className={"pricing-plan" + (isCurrent ? " current" : "")}>
            <h2 className="plan-title">
                {name}
            </h2>
            <div className="plan-price">
                <div className="plan-price-inner">
                    {displayAmount}
                    {trialPeriod && (
                        <p className="plan-trial">
                            {trialPeriod.frequency}-day free trial
                        </p>
                    )}
                </div>
            </div>

            <button
                className="plan-button"
                onClick={() => onChoose?.(id)}
            >
                {isCurrent ? "Current Plan" :"Choose Plan"}
            </button>

            {children}
        </section>
    );
}


function PricingPlans() {

    return <div className="pricing-plans">
        <PricingCard
            id="hobby"
            name="Hobby"
            amount="0"
            interval="month"
            isCurrent={true}
            onChoose={() => {
                // Handle plan selection
                console.log("Hobby plan selected");
            }}
        >
            <p className="plan-description">
                <ul>
                    <li>1 admin user</li>
                    <li>1 proxy</li>
                    <li>10 Filters</li>
                </ul>
            </p>
        </PricingCard>

        <PricingCard
            id="startup"
            name="Startup"
            amount="2900"
            interval="month"
            trialPeriod={{ frequency: 30 }}
            isCurrent={false}
            onChoose={() => {
                // Handle plan selection
                console.log("Startup plan selected");
            }}
        >
            <p className="plan-description">
                <ul>
                    <li>up to 3 admin users</li>
                    <li>up to 3 proxies</li>
                    <li>up to 20 filters</li>
                    <li>community support</li>
                    <li>no SLAs</li>
                </ul>
            </p>
        </PricingCard>

        <PricingCard
            id="growth"
            name="Growth"
            amount="14900"
            interval="month"
            trialPeriod={{ frequency: 30 }}
            isCurrent={false}
            onChoose={() => {
                // Handle plan selection
                console.log("Growth plan selected");
            }}
        >
            <p className="plan-description">
                <ul>
                    <li>up to 10 admin users</li>
                    <li>up to 20 proxies</li>
                    <li>up to 100 filters</li>
                    <li>Tier 2 support</li>
                    <li>99.9 SLA</li>
                </ul>
            </p>
        </PricingCard>

        <PricingCard
            id="enterprise"
            name="Enterprise"
            amount="sales"
            isCurrent={false}
            onChoose={() => {
                // Handle plan selection
                console.log("Enterprise plan selected");
            }}
        >
            <p className="plan-description">
                <ul>
                    <li>Tier 1 support</li>
                    <li>custom SLAs</li>
                </ul>
            </p>
        </PricingCard>
    </div>
}

export default PricingPlans;